import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children, roles = [] }) => {
  console.log('[PrivateRoute Debug] Entering PrivateRoute', { roles, children });
  
  const authContext = useAuth();
  console.log('[PrivateRoute Debug] useAuth() returned:', authContext);

  const { user, loading } = authContext || {};

  console.log('[PrivateRoute Debug] Auth state:', { user, loading });

  if (loading) {
    console.log('[PrivateRoute Debug] Loading is true, rendering loader');
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="relative inline-block">
            <div className="animate-spin rounded-full h-16 w-16 border-4 border-[#e2e8f0]"></div>
            <div className="animate-spin rounded-full h-16 w-16 border-4 border-[#1a3884] border-t-transparent absolute inset-0"></div>
          </div>
          <p className="mt-4 text-gray-600 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    console.log('[PrivateRoute Debug] No user, redirecting to /login');
    return <Navigate to="/login" replace />;
  }

  if (roles && roles.length > 0) {
    const userRole = user.role;
    console.log('[PrivateRoute Debug] Checking roles:', { roles, userRole });
    if (!roles.includes(userRole)) {
      console.warn('[PrivateRoute Debug] Access denied. User role:', userRole, 'not in allowed roles:', roles);
      return <Navigate to="/access-denied" replace />;
    }
  }

  console.log('[PrivateRoute Debug] Access granted, rendering children');
  return children;
};

export default PrivateRoute;
